import { Component } from '@angular/core';

const LCC_SITE = 'https://www.lincolnshire.gov.uk';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  menuOpen = false;

  menuItems = [
    { label: 'Schools and education', href: `${LCC_SITE}/schools-education` },
    { label: 'Roads and transport', href: `${LCC_SITE}/roads-transport` },
    { label: 'Jobs and careers', href: `${LCC_SITE}/jobs-careers` },
    {
      label: 'Births, deaths and ceremonies',
      href: `${LCC_SITE}/births-deaths-ceremonies`,
    },
    { label: 'Recycling and waste', href: `${LCC_SITE}/recycling-waste` },
    {
      label: 'Council and councillors',
      href: `${LCC_SITE}/council-councillors`,
    },
    {
      label: 'Childcare and family support',
      href: `${LCC_SITE}/childcare-family-support`,
    },
    { label: 'Libraries and leisure', href: `${LCC_SITE}/libraries-leisure` },
    {
      label: 'Environment and planning',
      href: `${LCC_SITE}/environment-planning`,
    },
    { label: 'Social care and health', href: `${LCC_SITE}/social-care-health` },
    {
      label: 'Fire, emergencies and crime',
      href: `${LCC_SITE}/fire-emergencies-crime`,
    },
    { label: 'Business and consumer', href: `${LCC_SITE}/business-consumer` },
    { label: 'Latest news', href: `${LCC_SITE}/news` },
    { label: 'Translation', href: `${LCC_SITE}/comments-feedback/languages` },
  ];

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
}
